import { Download, Layers, Link, Radio, RefreshCw, Signpost, Smartphone, Sparkles, Utensils } from "lucide-react";
import guide from "../../content/nfc-guide.json";

const ICONS = { Radio, Utensils, Sparkles, Link, Signpost, RefreshCw, Smartphone, Layers };

// Ilustraciones de cada sección; el JSON las nombra con su ruta relativa a src/content.
const IMAGES = Object.fromEntries(
    Object.entries(import.meta.glob("../../content/nfc-guide/*.svg", { eager: true, as: "url" }))
        .map(([path, url]) => [path.replace("../../content/", ""), url]),
);

export default function NfcGuide() {
    return (
        <main className="h-full w-full self-stretch overflow-y-auto overflow-x-hidden bg-base-200 text-base-content">
            <section className="mx-auto max-w-6xl px-4 pb-16 pt-10 sm:px-8 sm:pt-16">
                <div className="grid gap-8 border-b border-base-300 pb-12 md:grid-cols-[1.2fr_.8fr] md:items-end">
                    <div>
                        <p className="mb-3 text-sm font-semibold tracking-wide text-primary">NFC INTEGRADO</p>
                        <h1 className="max-w-3xl text-4xl font-black leading-tight tracking-tight text-balance sm:text-6xl">{guide.title}</h1>
                        <p className="mt-5 max-w-xl text-lg leading-relaxed text-base-content/70">{guide.intro}</p>
                    </div>
                    <a className="btn btn-primary gap-2 md:justify-self-end" href="/docs/guia-nfc.pdf" download>
                        <Download className="h-4 w-4" /> Descargar PDF
                    </a>
                </div>

                <div className="mt-12 grid gap-x-12 gap-y-10 md:grid-cols-2">
                    {guide.sections.map((section, index) => {
                        const Icon = ICONS[section.icon];
                        return (
                            <article key={section.id} className="border-t border-base-300 pt-5">
                                <div className="flex items-start gap-4">
                                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"><Icon className="h-5 w-5" /></span>
                                    <div className="min-w-0 flex-1">
                                        <p className="text-xs font-semibold tracking-wide text-base-content/45">0{index + 1}</p>
                                        <h2 className="mt-1 text-xl font-bold">{section.title}</h2>
                                        {section.quote && <blockquote className="mt-3 border-l-2 border-primary pl-3 font-medium italic">«{section.quote}»</blockquote>}
                                        <p className="mt-3 max-w-prose leading-relaxed text-base-content/70">{section.body}</p>
                                        {IMAGES[section.image] && <img src={IMAGES[section.image]} alt="" className="mt-4 w-full rounded-2xl" loading="lazy" />}
                                        {section.items && <ul className={`mt-3 grid gap-1 text-sm text-base-content/70 ${section.items.some((item) => item.length > 40) ? "" : "sm:grid-cols-2"}`}>{section.items.map((item) => <li key={item}>• {item}</li>)}</ul>}
                                        {section.steps && <ol className="mt-3 space-y-2 text-sm text-base-content/70">{section.steps.map((step, stepIndex) => <li key={step} className="flex gap-2"><span className="font-semibold text-primary">{stepIndex + 1}.</span>{step}</li>)}</ol>}
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>

                <section className="mt-14 rounded-2xl bg-base-100 p-6 shadow-sm ring-1 ring-base-300 sm:p-9">
                    <p className="text-sm font-semibold tracking-wide text-primary">DECIDE ANTES DE FABRICAR</p>
                    <h2 className="mt-2 text-3xl font-black tracking-tight">¿Qué quieres que haga tu llavero?</h2>
                    <p className="mt-3 max-w-2xl text-base-content/70">Indícalo al enviar tu solicitud o más adelante. Programaremos el chip antes de fabricar.</p>
                    <div className="mt-6 flex flex-wrap gap-2">
                        {guide.functions.map((item) => <span key={item.value} className="badge badge-lg border-base-300 bg-base-200 font-medium">{item.label}</span>)}
                    </div>
                </section>
            </section>
        </main>
    );
}
